module.exports = __webpack_public_path__ + "static/media/radar.353b8c0a.svg";